// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__zBknb","content":"LayoutSettings_content__2g4kh"};